import React from "react";
import { Youtube, Instagram, Facebook, Globe } from "lucide-react";
import { motion } from "framer-motion";

const socialLinks = [
  {
    name: "YouTube",
    href: "https://www.youtube.com/@Solapur_property_",
    icon: <Youtube className="h-6 w-6" />,
    bg: "from-red-500 to-red-600",
    hoverBg: "from-red-600 to-red-700",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/solapur_property_?igsh=M2lta2RrZzNtZ20%3D&utm_source=qr",
    icon: <Instagram className="h-6 w-6" />,
    bg: "from-pink-500 to-purple-500",
    hoverBg: "from-pink-600 to-purple-600",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/1A4LqVxuh8/?mibextid=wwXIfr",
    icon: <Facebook className="h-6 w-6" />,
    bg: "from-blue-500 to-blue-600",
    hoverBg: "from-blue-600 to-blue-700",
  },
  {
    name: "Website",
    href: "/",
    icon: <Globe className="h-6 w-6" />,
    bg: "from-emerald-500 to-emerald-600",
    hoverBg: "from-emerald-600 to-emerald-700",
  },
];

export default function SocialRedirectPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4">
      
      <div className="w-full max-w-md">
        
        {/* Card */}
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl shadow-2xl p-8 text-center">
          
          {/* Logo / Title */}
          <h1 className="text-3xl font-bold text-white mb-2">
            Skyline Properties
          </h1>
          <p className="text-gray-300 mb-8">
            Connect with us on social media
          </p>

          {/* Social Buttons */}
          <div className="space-y-4">
            {socialLinks.map((item, index) => (
              <motion.a
                key={index}
                href={item.href}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                className={`flex items-center justify-center gap-3 w-full py-4 rounded-2xl text-white font-semibold bg-gradient-to-r ${item.bg} hover:bg-gradient-to-r hover:${item.hoverBg} shadow-lg transition-all duration-300`}
              >
                {item.icon}
                {item.name}
              </motion.a>
            ))}
          </div>

          {/* Footer */}
          <p className="text-gray-400 text-sm mt-8">
            © {new Date().getFullYear()} Solapur Property
          </p>
        </div>
      </div>
    </div>
  );
}
